import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers';
import {
    PaymentMethod, UpdatePaymentMethodVariables,
} from '@api/graphql/types';
import Paths from '@root/utils/Path';
import * as Constants from '../constants';
import Form from '@components/Form/Form';

type Props = {
    paymentMethodId?: number,
} & InjectedIntlProps & RouteComponentProps<{paymentMethodId: string}>;

interface State {
    formData: UpdatePaymentMethodVariables;
    code: string;
}

class PaymentMethodEdit extends React.Component<Props, State> {
    public state = {
        formData: {
            id: '',
            name: '',
            is_active: false,
            sort: 0,
            short_description: '',
            short_description_mpl_type: '',
            cost: 0,
        },
        code: '',
    };

    public componentDidMount() {
        GraphQLClient.query<PaymentMethod>({
            query: Queries.adminPaymentMethod,
            variables: {id: parseInt(this.props.match.params.paymentMethodId, 10)},
        }).then((response) => {
            if (response.data && response.data.adminPaymentMethodById) {
                this.setState({
                    formData: response.data.adminPaymentMethodById,
                    code: response.data.adminPaymentMethodById.code,
                });
            }
        });
    }

    public onSubmit = (formData: UpdatePaymentMethodVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updatePaymentMethod, variables: formData,
        });
    }

    public onFormDataChange = (formData: UpdatePaymentMethodVariables) => {
        this.setState({formData});
    }

    private validate(): boolean {
        return true;
    }

    public render() {
        const fields = [
            {name: 'name', type: 'text'},
            {name: 'is_active', type: 'checkbox'},
            {name: 'short_description', type: 'textarea', props: {height: '10em'}},
        ];

        if (this.state.code === Constants.cashOnDelivery) {
            fields.push({name: 'short_description_mpl_type', type: 'textarea', props: {height: '10em'}});
            fields.push({name: 'cost', type: 'number'});
        }

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                        <Form
                            fields={[{id: 'default', fields}]}
                            intlPrefix={'module.paymentMethod'}
                            onSubmit={this.onSubmit}
                            formData={this.state.formData}
                            redirectPath={Paths.paymentMethod}
                            validate={this.validate}
                            onChange={this.onFormDataChange}
                        />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { paymentMethodId } = props.match.params;
    return { paymentMethodId: parseInt(paymentMethodId, 10) };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(PaymentMethodEdit);



// WEBPACK FOOTER //
// ./src/modules/PaymentMethod/pages/PaymentMethodEdit.tsx